/* Page loader — pulsujące logo Kickback zamiast systemowego browser spinnera.
 * Aktywuje się na kliknięciu linku wewnętrznego / submit formularza / beforeunload.
 * Ukrywa na pageshow (bfcache back button) i po init w razie gdyby był aktywny z poprzedniej strony.
 */
(function () {
	var loader = document.querySelector('[data-kb-loader]');
	if (!loader) return;

	function show() { loader.classList.add('is-active'); }
	function hide() { loader.classList.remove('is-active'); }

	// Klik w link → jeśli same-origin nawigacja → pokaż loader.
	document.addEventListener('click', function (e) {
		// Standard modifier keys / non-left click → nie pokazuj (browser i tak otworzy w tle/nowej karcie).
		if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
		var a = e.target.closest('a[href]');
		if (!a) return;
		var href = a.getAttribute('href');
		if (!href) return;
		// Anchor / JS / mail / tel → pomiń.
		if (href.charAt(0) === '#' || /^(javascript:|mailto:|tel:|sms:)/i.test(href)) return;
		// Cel _blank / download → pomiń.
		if (a.target === '_blank' || a.hasAttribute('download')) return;
		// data-cart-open, data-search-open, data-mega-tpl itd — to nie nawigacja tylko UI toggle.
		if (a.hasAttribute('data-cart-open') || a.hasAttribute('data-search-open')) return;

		try {
			var url = new URL(href, location.origin);
			if (url.origin !== location.origin) return; // external
			// Ten sam URL (klik na aktualną stronę) — nie zaśmiecajmy overlayem.
			if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
		} catch (err) { return; }

		show();
	}, true);

	// Submit formularza (checkout / add-to-cart / newsletter etc.) → pokaż loader.
	document.addEventListener('submit', function (e) {
		var form = e.target;
		if (!(form instanceof HTMLFormElement)) return;
		// Ignoruj forms które są AJAX (nie nawigują) — nasze mają preventDefault w handlerze.
		// Prosta heurystyka: jeśli e.defaultPrevented przy capture-phase to jeszcze nie zadziała, ale i tak
		// AJAX'y wywołują show/hide same. Dla wszystkich niezłapanych formów pokazujemy.
		if (form.hasAttribute('data-no-loader')) return;
		// Wysyłka zatrzymana (walidacja, AJAX) nie prowadzi na nową stronę — loader zostałby na zawsze.
		// Nasłuch jest na document w fazie bąbelkowania, więc handlery formularza już zdążyły zadziałać.
		if (e.defaultPrevented) return;
		show();
	}, false);

	// Bfcache: back / forward button → strona odzyskana z pamięci, ukryj loader który mógł zostać aktywny.
	window.addEventListener('pageshow', hide);
	window.addEventListener('pagehide', function () { /* keep visible during real navigation */ });
})();
